/* eslint-disable react/prop-types */
import { Switch, Tooltip } from '@mui/material';

const ShowOriginalToggle = (props) => {
  const { isShowingOriginal, onToggle, sx } = props;

  return (
    <Tooltip
      arrow
      placement='top'
      title={isShowingOriginal ? 'Showing original prescription' : 'Show original prescription'}
    >
      <Switch
        size='small'
        checked={isShowingOriginal}
        onChange={onToggle}
        inputProps={{ 'aria-label': 'toggle original drug' }}
        sx={{ ml: 0.25, transform: 'scale(0.75)', transformOrigin: 'left center', ...sx }}
      />
    </Tooltip>
  );
};

export default ShowOriginalToggle;
